import React, { useState } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import { decodeAccount } from '../utils/utils';
import DialogForm from './DialogForm';

import { CSVLink, CSVDownload } from "react-csv";

export default function ExportAccountsDialog({ open, onAdd, onClose,p_key }) {
    const [name, setName] = useState('');
    const [isImport, setIsImport] = useState(true);
    const [importedPrivateKey, setPrivateKey] = useState('');

    const importedAccount = isImport
        ? decodeAccount(importedPrivateKey)
        : undefined;
    const isAddEnabled = isImport ? name && importedAccount !== undefined : false;


    // console.log("isAddEnabled",isAddEnabled);
    const csvData = [
        ["firstname", "lastname", "email"],
        ["Ahmed", "Tomi", "ah@smthing.co.com"],
        ["Raed", "Labes", "rl@smthing.co.com"],
        ["Yezzi", "Min l3b", "ymin@cocococo.com"]
    ];



    return (
        <DialogForm
            open={open}
            onEnter={() => {
                setName('');
                setIsImport(true);
                setPrivateKey('');
            }}
            onClose={onClose}
            onSubmit={() => onAdd({ name, importedAccount })}
            fullWidth
        >
            <DialogTitle>Export Wallet</DialogTitle>
             {/* <DialogTitle>{JSON.stringify(p_key)}</DialogTitle> */}
            <DialogContent style={{ paddingTop: 16 }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >

                    <CSVLink data={p_key} filename='Private_keys' >Download me</CSVLink>

                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                {/* <Button type="submit" color="primary" disabled={!isAddEnabled}>
                    Add
                </Button> */}
            </DialogActions>
        </DialogForm>
    );
}
